import { Routes } from "@angular/router";
import { PlanFactPageComponent } from "./plan-fact-page.component";
import { authGuard } from "../../../core/guards/auth.guard";

export const planFactPageRoutes: Routes = [
  {
    path: 'records/plan-fact',
    component: PlanFactPageComponent,
    canActivate: [authGuard]
  }
]
